import { AccordionRoot } from "../../atoms/accordion/AccordionRoot";
import AccordionItemWithHeader from "../../molecules/accordion/AccordionItemWithHeader";

const Accordion = ({ items, type = "single", collapsible = true }) => {
  return (
    <AccordionRoot type={type} collapsible={collapsible}>
      {items.map((it) => (
        <AccordionItemWithHeader
          key={it.value}
          value={it.value}
          title={it.title}
        >
          {it.content}
        </AccordionItemWithHeader>
      ))}
    </AccordionRoot>
  );
};

export default Accordion;
